import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface CacheViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class CacheViewPage extends Component<CacheViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.cache(this.props),
                    view: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}